import React from "react";
import "../css/privacy.scss";

const questions = [
  ["How much is shipping?", "Shipping is a flat $9.99 USD per order."],
  ["When will my order be dispatched?", "We aim to dispatch promptly. Timing may be extended during peak periods, and tracking is emailed after dispatch."],
  ["Can I change my order?", "Contact us as soon as possible. We cannot guarantee changes after an order enters fulfilment."],
  ["How do returns work?", "Eligible unused items may be returned within 14 days. Review the Returns & Exchanges page before sending anything back."],
  ["Where do I enter card details?", "Card details are entered only on the secure payment provider page after you select Pay Now."],
  ["How can I contact Cewillow Market?", "Email import@cewillowmarket.life and include your order number when asking about an order."],
];

function Faqs() {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Frequently Asked Questions</h1>
        <div className="content-section">
          {questions.map(([question, answer]) => (
            <div className="policy-block" key={question}>
              <h3>{question}</h3>
              <p>{answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Faqs;
